"use strict";

(function () {
  'use strict';

  function SignupCtrl(UtilsService, LoginService, LRNotification, vcRecaptchaService, $state, AuthService) {
    var vm = this;
    this.showForm = false;
    vm.submitted = 0;
    vm.errMsg = '';
    vm.successMessage = '';
    vm.gRecaptchaResponse = null;

    vm.setResponse = function (response) {
      vm.errMsg = '';
      vm.gRecaptchaResponse = response;
    };

    vm.setWidgetId = function (widgetId) {
      console.info('Created widget ID: %s', widgetId);
      vm.widgetId = widgetId;
    };

    vm.cbExpiration = function () {
      console.info('Captcha expired. Resetting response object');
      vcRecaptchaService.reload(vm.widgetId);
      vm.response = null;
    };

    vm.socialLogin = function (provider) {
      var _provider = '';

      switch (provider) {
        case 'facebook':
          _provider = '/login/facebook';
          break;

        case 'google':
          _provider = '/login/google';
          break;
      }

      if ($state.params.returnto) {
        $cookies.put('socialReturn', $state.params.returnto);
      }

      var host = location.protocol + '//' + location.hostname + (location.port ? ':' + location.port : '');
      var width = 500;
      var height = 400;
      var left = window.innerWidth / 2 - width / 2;
      var top = window.innerHeight / 2 - height / 2;
      var popup = window.open(host + _provider + '?role=guest&callbackURL=' + host + '/login/callback', 'Login', 'location=1,toolbar=1,menubar=1,resizable=1,width=' + width + ',height=' + height + ',left=' + left + ',top=' + top);

      popup.onbeforeunload = function (e) {//console.log('onbeforeunload');
      };

      window.addEventListener('message', socialListener, false);

      function socialListener(e) {
        // make sure message is coming from trusted source (self)
        if (event.origin !== host) return; // successful login

        if (AuthService.isValidToken(e.data)) {
          var _token = e.data;
          AuthService.saveToken(_token);
          setTimeout(function () {
            $state.go('dashboard');
          });
        }

        window.removeEventListener('message', socialListener);
        popup.close();
      }
    };

    vm.signup = function (form, data) {
      vm.submitted++;
      vm.errMsg = '';
      vm.successMessage = '';

      if (!UtilsService.Form.isValid(form)) {
        UtilsService.Form.validateForm(form);
      } else {
        vm.loading = 'signup';
        UtilsService.Recaptcha.validate(vm.gRecaptchaResponse).then(function (responseData) {
          if (!responseData.success) {
            vm.errMsg = 'Recaptcha verification expired. Please Try again.';
            vcRecaptchaService.reload(vm.widgetId);
          } else {
            var shaObj = new jsSHA('SHA-256', 'TEXT');
            shaObj.setHMACKey(data.email.toLowerCase(), 'TEXT');
            shaObj.update(data.password);
            var hash = shaObj.getHMAC('HEX');
            LoginService.signup({
              firstName: data.firstName,
              lastName: data.lastName,
              email: data.email.toLowerCase(),
              password: hash
            }).then(function (response) {
              vm.successMessage = 'A verification email has been sent to you. Please view your email and click the link provided in it.';
              vm.loading = false;
            }, function (errorMessage) {
              if (errorMessage && typeof errorMessage === 'string') {
                LRNotification.error(errorMessage, 3500);
              } else {
                LRNotification.error('Error signing up. Please try again.', 3500);
              }

              vcRecaptchaService.reload(vm.widgetId);
              vm.loading = false;
            });
          }
        }, function (error) {
          console.log(error);
          vcRecaptchaService.reload(vm.widgetId);
        });
      }
    };
  }

  SignupCtrl.$inject = ['UtilsService', 'LoginService', 'LRNotification', 'vcRecaptchaService', '$state', 'AuthService'];
  angular.module('view.login').component('signUp', {
    bindings: {},
    controller: SignupCtrl,
    templateUrl: 'views/login/components/sign-up/sign-up.html'
  });
})();